import { render, staticRenderFns } from "./garden15.vue?vue&type=template&id=717820d7&"
import script from "./garden15.vue?vue&type=script&lang=js&"
export * from "./garden15.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports